export default __webpack_public_path__ + "images/PF.c9948c0.png";